import React, { useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent } from "@material-ui/core";

const isVideo = (url = "") => /\.(mp4|webm|ogg|mov|m4v)(\?|#|$)/i.test(url);

function DialogMediaViewer({ openFullImage, handleImageClose, tile, buildShapperPath }) {
    const medias = useMemo(
        () => (tile?.media_urls || []).map(m => ({ ...m, fullSrc: buildShapperPath(m.url) })),
        [tile, buildShapperPath]
    );

    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        if (openFullImage) setSelectedIndex(0);
    }, [openFullImage, tile?.media_urls?.length]);

    const selected = medias[selectedIndex];

    return (
        <Dialog open={openFullImage} onClose={handleImageClose} maxWidth="lg" fullWidth>
            <DialogContent
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    padding: 20,
                    height: "80vh",
                    boxSizing: "border-box",
                }}
            >
                {medias.length > 0 && (
                    <>
                        {/* Média principal */}
                        <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {selected && isVideo(selected.url) ? (
                                <video
                                    src={selected.fullSrc}
                                    controls
                                    playsInline
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        borderRadius: 8,
                                    }}
                                />
                            ) : (
                                <img
                                    src={selected?.fullSrc}
                                    alt="Full Size"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        borderRadius: 8,
                                    }}
                                />
                            )}
                        </div>

                        {/* Colonne des miniatures */}
                        <div
                            style={{
                                width: 120,
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingRight: 10,
                            }}
                        >
                            {medias.map((media, index) => {
                                const active = index === selectedIndex;

                                const commonStyle = {
                                    width: "100%",
                                    height: 80,
                                    marginBottom: 10,
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    boxShadow: active ? "0 0 0 2px #3f51b5" : "0 2px 6px rgba(0, 0, 0, 0.2)",
                                    transition: "transform 0.2s",
                                    objectFit: "cover",
                                    display: "block",
                                };

                                return isVideo(media.url) ? (
                                    <video
                                        key={index}
                                        src={media.fullSrc}
                                        muted
                                        playsInline
                                        preload="metadata"
                                        style={commonStyle}
                                        onClick={() => setSelectedIndex(index)}
                                        onMouseOver={e => (e.currentTarget.style.transform = "scale(1.05)")}
                                        onMouseOut={e => (e.currentTarget.style.transform = "scale(1)")}
                                    />
                                ) : (
                                    <img
                                        key={index}
                                        src={media.fullSrc}
                                        alt={`Thumbnail ${index + 1}`}
                                        style={commonStyle}
                                        onClick={() => setSelectedIndex(index)}
                                        onMouseOver={e => (e.currentTarget.style.transform = "scale(1.05)")}
                                        onMouseOut={e => (e.currentTarget.style.transform = "scale(1)")}
                                    />
                                );
                            })}
                        </div>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default DialogMediaViewer;